
import Enumerable from "linq";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { IDepartmentDialogCondition } from "../IDepartmentDialogCondition";
import { Department, DepartmentGroup } from "../../../../domain/department";
import {
  SelectorDialogMixin,
  ISingleSelectableAsynchronously,
  ISingleSelectableConditionallyAsynchronously,
  IDialogCondition,
} from "../../../system";
import { StandardOption } from "../../../system/selectors/mixins";
import { UserAuthority } from "../../../../domain/authentication";

@Component
export default class DepartmentButtonSelectorDialogMixin extends Mixins(SelectorDialogMixin)
implements ISingleSelectableAsynchronously<Department>, ISingleSelectableConditionallyAsynchronously<Department, IDialogCondition> {
  @Prop({ default: "診療科" })
  name: boolean;

  data(): any {
    return {
      currentCondition: null,
    };
  }
  currentCondition: IDepartmentDialogCondition;

  get title(): string {
    const name = (this.currentCondition && this.currentCondition.name)
      ? this.currentCondition.name
      : this.name;
    return name + "選択";
  }

  get isCancelable(): boolean {
    return (this.currentCondition && this.currentCondition.isCancelable !== undefined)
      ? this.currentCondition.isCancelable
      : true;
  }

  get departmentGroup(): DepartmentGroup {
    return !!this.currentCondition
      ? this.currentCondition.departmentGroup
      : undefined;
  }

  get shouldShowReferenceableGroupDepartments(): boolean {
    return !!this.currentCondition
      ? this.currentCondition.shouldShowReferenceableGroupDepartments
      : undefined;
  }

  filterDepartment(option: StandardOption<Department>): boolean {
    // TODO: refactor
    // StandardOptionを意識しないで済むようにselector内部で頑張って欲しい
    const isAdminDepartmentsOnly = (this.currentCondition && this.currentCondition.isAdministratorDepartmentsOnly);
    const userAuthority = this.$store.getters.userAuthority as UserAuthority;
    if (isAdminDepartmentsOnly && !Enumerable.from(userAuthority.administratorDepartmentIds).any(id => !!option && !!option.value && option.value.id === id)) {
      // その診療科の管理権限が無い
      return false;
    }
    const isUserDepartmentsOnly = (this.currentCondition && this.currentCondition.isUserDepartmentsOnly);
    const userDepartments = this.$store.getters.userDepartments as Department[];
    // どの診療科にも所属していないときは全ての診療科を表示する
    if (!isUserDepartmentsOnly || !userDepartments || userDepartments.length === 0) { return true; }
    return option && userDepartments.some(d => d.id === option.value.id);
  }

  async selectOption(defaultOption?: Department): Promise<Department> {
    const userDepartments = this.$store.getters.userDepartments as Department[];
    if (!!userDepartments && userDepartments.length === 1) { return userDepartments[0]; }
    return this.show<Department>(defaultOption);
  }

  async selectOptionConditionally(condition: IDepartmentDialogCondition, defaultOption?: Department): Promise<Department> {
    const userDepartments = this.$store.getters.userDepartments as Department[];
    const isUserDepartmentsOnly = (condition && condition.isUserDepartmentsOnly);
    if (isUserDepartmentsOnly && !!userDepartments && userDepartments.length === 1) { return userDepartments[0]; }
    this.currentCondition = condition;
    const result = await this.show<Department>(defaultOption);
    this.currentCondition = null;
    return result;
  }

  onClicked() {
    this.select();
  }
}
